import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";
import { Project } from '../models/project.model';
import { Region } from "../models/region.model";
import { GraphicSettings } from "../models/GraphicSettings.model";
import { ComfortType } from "../models/comfort.mode";
import { TransportMode } from "../models/transportMode.model";
import { TravelMix } from "../models/TravelMix.model";
import { Graphic } from "../models/graphic.model";
import { dynamicLocaleCompareWithOptions } from "../helper/sortFunctions";
import { EvaluationFrontendParameter } from "../models/EvaluationFrontendParameter.model";

@Injectable()
export abstract class BaseEvaluationService<T extends EvaluationFrontendParameter> {
    public evaluationFrontEndParameter: T;
    public project: BehaviorSubject<Project> = new BehaviorSubject(null);
    public passengerAlgorithmGraphicSelected: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public regions: Region[];
    public companyGraphicSettings: GraphicSettings;
    comfortValues: ComfortType[];
    transportModes: TransportMode[];
    companyGraphics: Graphic[];
    allGraphics: Graphic[];
    travelMixListFiltered: TravelMix[] = [];
    travelMixList: TravelMix[];
    selectedTravelMixList: TravelMix[] = [];

    public initializeEvaluationFrontendParameter(parameter: T) {
        this.evaluationFrontEndParameter = parameter;
        this.evaluationFrontEndParameter.considerAllDecksForCalculation = false;
        this.passengerAlgorithmGraphicSelected.next(false);
    }

    public resetTravelMixList() {
        this.travelMixList = new Array<TravelMix>();
        this.travelMixListFiltered = new Array<TravelMix>();
        this.evaluationFrontEndParameter.travelMixList = new Array<number>();
        this.selectedTravelMixList = new Array<TravelMix>();
    }

    public setFilteredGraphics() {
        this.evaluationFrontEndParameter.graphicList = new Array<number>();
        this.companyGraphics = [];
        this.passengerAlgorithmGraphicSelected.next(false);
        setTimeout(() => {
            this.companyGraphics = this.companyGraphicSettings.settings;
        }, 100);
    }

    public addToSelectedTravelmixes(travelOption: TravelMix) {
        this.evaluationFrontEndParameter.travelMixList.push(travelOption.id);
        this.selectedTravelMixList.push(travelOption);
        this.selectedTravelMixList.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));
    }

    public removeFromSelectedtravelMixes(travelOption: TravelMix) {
        const index = this.evaluationFrontEndParameter.travelMixList.indexOf(travelOption.id);
        this.evaluationFrontEndParameter.travelMixList.splice(index, 1);
        const index1 = this.selectedTravelMixList.indexOf(travelOption);
        this.selectedTravelMixList.splice(index1, 1);
    }

    public syncEvaluationGraphics(graphics: number[]) {
        this.evaluationFrontEndParameter.graphicList = graphics;
        this.passengerAlgorithmGraphicSelected.next(this.isPassengerAlgorithmGraphicSelected());
    }

    public filterTravelMix(filter) {
        this.travelMixListFiltered = this.filterArray(this.travelMixList, filter);
    }

    private filterArray(array, filters) {
        const filterKeys = Object.keys(filters);
        let result = array.filter(item => {
            return filterKeys.every(key => {
                if (typeof filters[key] !== 'function') return true;
                return filters[key](item[key]);
            });
        });
        return result;
    }

    private isPassengerAlgorithmGraphicSelected() {
        let result = false;
        for (let index = 0; index < this.evaluationFrontEndParameter.graphicList.length; index++) {
            const graphicId = this.evaluationFrontEndParameter.graphicList[index];
            let graphic = this.companyGraphicSettings.settings.find(x => x.graphicId === graphicId);
            if (graphic.algorithmId == 2) {
                result = true;
                break;
            }
        }
        return result;
    }
}
